import * as Factory from 'factory.ts'
import faker from 'faker'

import { APCreditCardTypes } from '@webapp/models/enums'
import { CurrencyMock } from './currency.factory'
import { type CreditCard, type CreditCardAssignee } from '../../models'

export const CreditCardAssigneeMock =
  Factory.Sync.makeFactory<CreditCardAssignee>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    email: Factory.each(() => faker.internet.email()),
    profile_image: null,
  })

export const CreditCardMock = Factory.Sync.makeFactory<CreditCard>({
  name: Factory.each(() => faker.finance.accountName()),
  balance: null,
  category: null,
  created_at: Factory.each(() => faker.date.past().toISOString()),
  creator: null,
  currency: CurrencyMock.build().id,
  currency_name: 'CAD',
  external_id: '',
  gl_code: Factory.each(() => faker.random.alphaNumeric(5)),
  id: Factory.each(() => faker.random.number()),
  is_active: Factory.each(() => faker.random.boolean()),
  last_changed_by: null,
  number: '1234',
  payment_method: null,
  require_activation: false,
  status: 'active',
  type: APCreditCardTypes.AMERICAN_EXPRESS,
  updated_at: Factory.each(() => faker.date.past().toISOString()),
  uuid: Factory.each(() => faker.random.uuid()),
  vendor: Factory.each(() => faker.random.number(1)),
  assignees: Factory.each(() => CreditCardAssigneeMock.buildList(2)),
})
